// extracted by mini-css-extract-plugin
var _1 = "EntityTabContractTableRow-moduleEntityTabContractTableRow__YY1PD TableComponent-modulerow__xPAo4";
export { _1 as "EntityTabContractTableRow" }
